import { FC } from 'react';
import { StanLink, StanToggle } from '@/components';
import { BareSvg } from '@/lib/bareSvg';
import { MenuMoreViewProps } from '../types';
import IcPin from '@/assets/icons/ic-pin-filled.svg';
import { MenuItemType } from '@/types';

export const PinnableItemsView: FC<MenuMoreViewProps> = ({
    pinnableItems,
    adminItems,
    onItemClick,
    onToggle,
    isItemPinned,
    isToggleDisabled,
}) => {
    const renderItemWithToggle = (item: MenuItemType) => {
        const disabled = isToggleDisabled(item);
        const pinned = isItemPinned(item);

        return (
            <div
                key={item.id}
                className='shadow-nucleus-elevation-low focus-within:ring-brand-subtle flex items-center justify-between rounded-2xl bg-white p-2.5 transition-shadow duration-200 focus-within:ring-4 md:p-4'
            >
                <StanLink
                    to={item.route}
                    className='flex w-full cursor-pointer items-start gap-2.5 text-left transition-colors duration-200 focus-visible:outline-none md:gap-4'
                    onClick={() => onItemClick(item)}
                >
                    <div className='bg-brand-subtle flex aspect-square size-16 items-center justify-center rounded-md p-2.5 md:size-20'>
                        <BareSvg
                            SvgComponent={item.icon}
                            className='text-dark size-full'
                            removeFill={item.removeFill}
                        />
                    </div>
                    <div className='flex flex-col gap-1 pt-0.5 md:pt-1.5'>
                        <div className='flex items-start gap-1'>
                            <div className='text-heading-h4 md:text-heading-h3 text-dark'>{item.title}</div>
                            {pinned && <BareSvg SvgComponent={IcPin} className='mt-1 size-3 md:size-4' />}
                        </div>
                        {item.subTitle && (
                            <div className='text-caption-2-regular md:text-caption-1-regular text-gray'>
                                {item.subTitle}
                            </div>
                        )}
                    </div>
                </StanLink>
                <StanToggle checked={pinned} onChange={() => onToggle(item)} disabled={disabled} toggleSize='sm' />
            </div>
        );
    };

    return (
        <div className='desktop-apps-wrapper space-y-8'>
            {pinnableItems.length > 0 && (
                <div className='grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8'>
                    {pinnableItems.map(renderItemWithToggle)}
                </div>
            )}
            {adminItems.length > 0 && (
                <div className='mt-4'>
                    <h2 className='text-dark mb-4'>Stan Admin</h2>

                    <div className='grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8'>
                        {adminItems.map(renderItemWithToggle)}
                    </div>
                </div>
            )}
        </div>
    );
};
